/**
 * TeamSystem Impact - Notification Store
 * Zustand store per gestione badge notifiche e polling
 */

import { create } from 'zustand';
import { notificationsApi } from '../api/notifications.api';

interface NotificationState {
  unreadCount: number;
  polling: boolean;
  intervalId: ReturnType<typeof setInterval> | null;

  fetchUnreadCount: () => Promise<void>;
  startPolling: () => void;
  stopPolling: () => void;
  resetUnread: () => void;
  markAllSeen: () => Promise<void>;
}

// Cresce a ogni seen-all riuscito: un conteggio chiesto prima arriva vecchio e va scartato
let seenEpoch = 0;

export const useNotificationStore = create<NotificationState>()((set, get) => ({
  unreadCount: 0,
  polling: false,
  intervalId: null,

  fetchUnreadCount: async () => {
    const epoch = seenEpoch;
    try {
      const count = await notificationsApi.getUnreadCount();
      if (epoch !== seenEpoch) return;
      set({ unreadCount: count });
    } catch {
      // Silently fail — polling will retry
    }
  },

  startPolling: () => {
    const state = get();
    if (state.polling) return;

    // Fetch immediately
    get().fetchUnreadCount();

    const intervalId = setInterval(() => {
      get().fetchUnreadCount();
    }, 60_000);

    set({ polling: true, intervalId });
  },

  stopPolling: () => {
    const state = get();
    if (state.intervalId) {
      clearInterval(state.intervalId);
    }
    set({ polling: false, intervalId: null });
  },

  resetUnread: () => {
    set({ unreadCount: 0 });
  },

  // Apertura della pagina Notifiche: azzera il badge, non segna come lette
  markAllSeen: async () => {
    try {
      await notificationsApi.markAllAsSeen();
      seenEpoch++;
      set({ unreadCount: 0 });
      // Riallinea col server: include le notifiche arrivate durante la PATCH
      await get().fetchUnreadCount();
    } catch {
      // Silently fail — il polling ripristina il conteggio reale
    }
  },
}));
